/**
 * useOfferedRuleActions — which actions the Rules-tab picker lists for the
 * drawer's tracker. The queue verbs (rotation, partner caps, backfill) run
 * only in the queue rotation, so a tracker without a queue (Tres Commas) is
 * not offered them; one already saved stays listed, can only be unticked, and
 * says why (its stale note). Voluum/Binom (with a queue) get every action.
 * Split out of RuleActionsSelect (size limit).
 * For Media Devoted | Created By Ciro Autiero
 */

import type { RuleAction } from '@trafficpulse/shared';

import { QUEUE_LIFECYCLE_ACTIONS } from '@/features/flow-optimizer/tabs/exclude/rule-action-compat';
import { RULE_ACTIONS } from '@/features/flow-optimizer/tabs/exclude/rule-action-meta';
import { useDrawerProfile, useFlowTrackerName } from '@/features/flow-optimizer/tracker';

export function useOfferedRuleActions(value: RuleAction[]) {
  const { queue } = useDrawerProfile();
  const note = `needs the queue — not run on ${useFlowTrackerName()} · untick to remove`;
  const queueOnly = (a: RuleAction) => !queue && QUEUE_LIFECYCLE_ACTIONS.includes(a);
  return {
    offered: RULE_ACTIONS.filter((a) => !queueOnly(a.value) || value.includes(a.value)),
    /** A saved queue verb on a tracker without a queue: inert, untick only. */
    staleNote: (a: RuleAction): string | undefined => (queueOnly(a) ? note : undefined),
  };
}
